<template>
  <div>
    <div class="row f-row mt-1 results-header">
      <div class="col col-12 analytics_results text-left">
        {{ isFEP ? "FEP" : "CIF ROTTERDAM" }} SWAP CALCULATIONS FOR:
        <div
          id="fep_date"
          class="inh ml-1"
          style="color: var(--textactive); font-size: 1rem;"
        >
          ...
        </div>
      </div>
    </div>
    <div class="row f-row mt-1 results-header">
      <div class="col col-12 analytics_results">
        <table class="table-borderless table-sm analytics_table">
          <tbody>
            <tr>
              <th>{{ isFEP ? "BMD" : "CIF ROTT" }} (USD / mt)</th>
              <th class="table-center-borders">FREIGHT (USD / mt)</th>
              <th>TARIFF (%)</th>
              <th class="table-center-borders">USD/COP</th>
              <th>PRICE (COP / mt)</th>
            </tr>
            <tr>
              <td style="color: var(--dark-fwd)!important;">
                <div id="fep_bmd" class="inh">0</div>
              </td>
              <td class="table-center-borders">
                <InputNumber
                  :tableFormat="true"
                  :value="newFreight"
                  @input="val => onUserFreightChange(val)"
                />
              </td>
              <td>
                <InputNumber
                  :tableFormat="true"
                  :value="newTariff"
                  @input="val => onUserTariffChange(val)"
                />
              </td>
              <td
                style="color: var(--fwd-h)!important;"
                class="table-center-borders"
              >
                <div id="fep_usdcop" class="inh">0</div>
              </td>
              <td style="font-size: 1.2rem; color: var(--hedge-h)!important;">
                <div id="fep_cop" class="inh">0</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row f-row mt-2 results-header">
      <div class="col col-12 analytics_results text-left">
        ZOOMED AVERAGE
        <div
          class="inh ml-1"
          style="color: var(--textactive); font-size: 1rem;"
        >
          {{ inDate | formatDate }}
        </div>
        to
        <div
          class="inh ml-1"
          style="color: var(--textactive); font-size: 1rem;"
        >
          {{ endDate | formatDate }}
        </div>
      </div>
    </div>
    <div class="row f-row mt-1 results-header">
      <div class="col col-12 analytics_results">
        <table class="table-borderless table-sm analytics_table">
          <tbody>
            <tr>
              <th>{{ isFEP ? "BMD" : "CIF ROTT" }} (USD / mt)</th>
              <th class="table-center-borders">FREIGHT (USD / mt)</th>
              <th>TARIFF (%)</th>
              <th class="table-center-borders">USD/COP</th>
              <th>PRICE (COP / mt)</th>
            </tr>
            <tr>
              <td style="color: var(--dark-fwd)!important;">
                {{ aveDataFEP.bmd | priceFormat }}
              </td>
              <td class="table-center-borders">
                <InputNumber
                  :tableFormat="true"
                  :value="newFreight"
                  @input="val => onUserFreightChange(val)"
                />
              </td>
              <td>
                <InputNumber
                  :tableFormat="true"
                  :value="newTariff"
                  @input="val => onUserTariffChange(val)"
                />
              </td>
              <td
                class="table-center-borders"
                style="color: var(--fwd-h)!important;"
              >
                {{ aveDataFEP.usdcop | priceFormat }}
              </td>
              <td style="font-size: 1.2rem; color: var(--hedge-h)!important;">
                {{ aveDataFEP.close | priceFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "d3";
import moment from "moment";
import InputNumber from "@/components/InputNumber";

export default {
  name: "CPOTableFEP",
  props: {
    freight: { required: true },
    tariff: { required: true },
    aveDataFEP: { required: true },
    isFEP: { required: true, type: Boolean, default: true },
    inDate: { required: true },
    endDate: { required: true }
  },
  components: {
    InputNumber
  },
  data() {
    return {
      newFreight: 0,
      newTariff: 0
    };
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.6r")(val);
    },
    formatDate: function(value) {
      if (value) {
        return moment(String(value))
          .format("MMM YY")
          .toUpperCase();
      }
    }
  },
  mounted() {
    this.newFreight = this.freight;
    this.newTariff = this.tariff;
  },
  watch: {
    freight() {
      this.newFreight = this.freight;
    },
    tariff() {
      this.newTariff = this.tariff;
    }
  },
  methods: {
    // === user interactions ===
    onUserFreightChange(val) {
      this.$emit("eventOnUserFreightChange", val);
    },
    onUserTariffChange(val) {
      this.$emit("eventOnUserTariffChange", val);
    }
  }
};
</script>

<style scoped></style>
